export default "__VITE_ASSET__Tek6cSht__"